import { render, staticRenderFns } from "./Places.vue?vue&type=template&id=00b84737"
import script from "./Places.vue?vue&type=script&lang=js"
export * from "./Places.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports